import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Typography } from '@material-ui/core';

const CustomSelect = (props) => {
  const {
    label, name, className, classes, control,
    rule, options, error, disabled, required,
    styleFromHelperText, inputProps, defaultValue,
    style, iconExpandMore, noWrap = false,
  } = props;
  return (
    <FormControl className={className} style={style} fullWidth>
      <Controller
        as={(
          <TextField
            label={label}
            size="small"
            variant="outlined"
            select
            disabled={disabled}
            required={required}
            FormHelperTextProps={styleFromHelperText || { style: { margin: '0 0 0 5px', color: '#d61103' } }}
            helperText={error[name] ? error[name].message : null}
            className={classes}
            SelectProps={{
              IconComponent: iconExpandMore || ArrowDropDownIcon,
            }}
          >
            <MenuItem value="">
              <em>Seleccione una opción</em>
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {noWrap ? (
                  <Typography
                    noWrap
                    variant="body1"
                  >
                    {option.label}
                  </Typography>
                ) : (
                  option.label
                )}
              </MenuItem>
            ))}
          </TextField>
        )}
        name={name}
        control={control}
        rules={rule}
        fullWidth
        error={Boolean(error[name])}
        inputProps={inputProps}
        defaultValue={defaultValue || ''}
      />
    </FormControl>
  );
};

export default CustomSelect;
